const applyTextColor = (editor, color) => {
  if (!editor || !color) return;

  let applied = false;

  try {
    applied = editor.execCommand('ForeColor', false, `#${color}`) !== false;
  } catch (e) {
    applied = false;
  }

  if (!applied) {
    try {
      // Keep fallback for older command aliases used in previous TinyMCE versions.
      editor.execCommand('mceApplyTextcolor', 'forecolor', `#${color}`);
    } catch (e) {
      // Ignore fallback errors to preserve non-throwing behavior.
    }
  }
};

export default applyTextColor;
